const ORDER_PRODUCT_MODEL_CLASS_NAME = 'OrderProduct'

const ORDER_PRODUCT_MODEL_KEY = {
  ID: 'id',
  CLASS_NAME: 'className',
  CREATED_AT: 'createdAt',
  UPDATED_AT: 'updatedAt',
  PRICE: 'price',
  QUANTITY: 'quantity',
  DATA: 'data',
  ORDER: 'order',
  PRODUCT: 'product',
  // Foreign keys
  ORDER_ID: 'orderId',
  PRODUCT_ID: 'productId'
}

/**
 * A mapping of property key to className.
 * @type {Object}
 */
const ORDER_PRODUCT_MODEL_ASSOCIATION = {
  [ORDER_PRODUCT_MODEL_KEY.PRODUCT]: 'Product'
}

export {
  ORDER_PRODUCT_MODEL_CLASS_NAME,
  ORDER_PRODUCT_MODEL_KEY,
  ORDER_PRODUCT_MODEL_ASSOCIATION
}
